<div class="pageNotFoundMessage">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-12 col-md-8 col-xl-9 mb-4">
                <div class="titleTyp4">
                    @if (maintenanceMode) {
                        our site is currently under maintenance
                    } @else {
                        it seems like we have a temporary technical issue
                    }
                </div>
            </div>
            <div class="col-12 col-md-4 col-xl-3 mb-4">
            </div>
        </div>        
    </div>
</div>
<div class="">
    <div class="boxTyp4 insertInFooter">
        <app-save-money-energy-bills></app-save-money-energy-bills>
    </div>
</div>